import React from 'react'
import AddAdminContainer from '../../../../../Components/UserPart/AddUser/AddAdminContainer/AddAdminContainer'
import Layout from '../../../Layout'

const AddAdmin = () => {
  return (
    <Layout>
        <AddAdminContainer/>
    </Layout>
  )
}

export default AddAdmin